import React, { useRef } from 'react';
import { LanguageToggle } from './LanguageToggle';
import { useLanguage } from '../i18n/useLanguage';
import { Sidebar, SidebarMenuItem } from './Sidebar';

type HeaderProps = {
  sidebarOpen: boolean;
  onToggleSidebar: () => void;
  menuItems: SidebarMenuItem[];
  sidebarFooterLinks?: { label: string; onClick: () => void }[];
};

export const Header: React.FC<HeaderProps> = ({ sidebarOpen, onToggleSidebar, menuItems, sidebarFooterLinks }) => {
  const { t } = useLanguage();
  const burgerRef = useRef<HTMLButtonElement>(null);

  return (
    <header
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 2000,
        background: 'rgba(255,255,255,0.85)',
        borderBottom: '1px solid rgba(255,106,76,0.3)',
        backdropFilter: 'blur(6px)',
      }}
    >
      <div
        style={{
          maxWidth: 1200,
          margin: '0 auto',
          padding: '10px 16px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          {/* Burger icon */}
          <button
            ref={burgerRef}
            onClick={onToggleSidebar}
            aria-expanded={sidebarOpen}
            aria-label={sidebarOpen ? t('sidebar.closeMenu' as any) : t('sidebar.openMenu' as any)}
            style={{
              border: 'none',
              background: 'transparent',
              cursor: 'pointer',
              fontSize: 24,
              minWidth: 44,
              minHeight: 44,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 0,
            }}
          >
            ☰
          </button>

          <LanguageToggle />
        </div>
      </div>

      {/* Sidebar */}
      <Sidebar
        isOpen={sidebarOpen}
        onClose={onToggleSidebar}
        items={menuItems}
        burgerIconRef={burgerRef}
        footerLinks={sidebarFooterLinks}
      />
    </header>
  );
};
